<div class="background"></div>
<div class="center">
  <p>404</p>
  <p>Pagina non trovata</p>
</div>
